import { render, staticRenderFns } from "./summeryTaskList.vue?vue&type=template&id=30661ae5&scoped=true&"
import script from "./summeryTaskList.vue?vue&type=script&lang=js&"
export * from "./summeryTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30661ae5",
  null
  
)

export default component.exports